import { render, staticRenderFns } from "./ComponentSearch.vue?vue&type=template&id=543a0ead&"
import script from "./ComponentSearch.vue?vue&type=script&lang=js&"
export * from "./ComponentSearch.vue?vue&type=script&lang=js&"
import style0 from "./ComponentSearch.vue?vue&type=style&index=0&id=543a0ead&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543a0ead')) {
      api.createRecord('543a0ead', component.options)
    } else {
      api.reload('543a0ead', component.options)
    }
    module.hot.accept("./ComponentSearch.vue?vue&type=template&id=543a0ead&", function () {
      api.rerender('543a0ead', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/components/ComponentSearch.vue"
export default component.exports